import axios from "axios"
import { environment } from "@configs/enviorment"
export const axiosInstance = axios.create({
  baseURL: environment.apiUrl
//   withCredentials: true
})
